import React from 'react'
import propTypes from 'prop-types'
import { Snackbar,Alert} from "@mui/material";


const SnackBar = ({  message, onClose, variant, open, time }) => {
    return (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={open}
          autoHideDuration={time}
          onClose={onClose}
        >
            <Alert onClose={onClose} severity={variant} sx={{ width: '100%' }}>
            {message}
            </Alert>

        </Snackbar>
    )
}

SnackBar.propTypes = {
    message: propTypes.string.isRequired,
    onClose: propTypes.func.isRequired,
    variant: propTypes.oneOf(['success', 'warning', 'error', 'info']),
    open: propTypes.bool.isRequired,
    button: propTypes.string,
    onClick: propTypes.func,
    closeIcon: propTypes.bool
}

export default SnackBar